var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g3, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _g4, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _g5, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceProvidersTabbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 577,
    viewBox: "0 0 652 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 343,
    y: 36,
    width: 250,
    height: 414
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.917 36.0383V449.412H592.162V36.0383H346.917ZM414.978 161.109C422.381 171.383 439.811 152.882 447.214 159.049C451.896 162.947 447.877 177.497 443.305 192.66C426.138 188.019 408.901 183.404 404.509 188.11C397.977 195.098 417.575 211.552 406.692 218.54C395.808 225.528 379.249 222.243 383.171 204.968C386.831 188.827 382.909 178.436 343.975 191.917V103.404H443.775C457.171 138.762 446.233 142.309 429.37 138.906C411.07 135.203 407.589 150.835 414.992 161.109H414.978Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.062 174.148C587.062 112.35 533.543 62.3631 467.871 63.2236C403.898 64.058 351.981 113.836 352.023 174.227C352.05 204.709 365.102 232.323 386.205 252.362C397.807 263.365 404.561 278.111 404.561 293.626V293.691C404.561 306.233 415.333 316.39 428.606 316.39H510.479C523.765 316.39 534.524 306.22 534.524 293.691V293.626C534.524 278.424 540.739 263.704 552.188 253C573.72 232.896 587.048 204.996 587.048 174.148H587.062Z",
    fill: "#FF5924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.176 316.389H520.903V382.242C520.903 389.035 515.061 394.55 507.865 394.55H431.213C424.018 394.55 418.176 389.035 418.176 382.242V316.389Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.903 316.389H418.176V334.068H520.903V316.389Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.126 394.565H425.964C425.964 402.675 432.939 409.259 441.529 409.259H497.561C506.152 409.259 513.126 402.675 513.126 394.565Z",
    fill: "#8CD4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.035 422.23H461.061C457.125 422.23 453.424 420.47 451.09 417.484L444.64 409.257H494.443L487.993 417.484C485.659 420.47 481.958 422.23 478.022 422.23H478.035Z",
    fill: "#40B7D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.176 352.31L520.903 340.563",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.176 367.222L520.903 355.475",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.176 382.138L520.903 370.391",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.456 395.086L520.905 385.308",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.651 314.474V285.582C452.651 278.815 458.451 273.34 465.619 273.34H474.445C481.613 273.34 487.413 278.815 487.413 285.582V316.39",
    stroke: "#FFEEE9",
    strokeWidth: 2.13399,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.015 274.067L423.771 173.469",
    stroke: "#FFEEE9",
    strokeWidth: 2.13399,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.197 274.067L510.91 173.469",
    stroke: "#FFEEE9",
    strokeWidth: 2.13399,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.771 181.345C436.798 167.329 451.77 183.483 441.591 185.386C431.426 187.29 436.315 172.309 454.449 168.476C472.583 164.63 471.368 178.841 462.004 179.611C452.654 180.38 454.85 163.483 476.326 165.399C497.802 167.316 500.869 184.213 489.074 182.296C477.279 180.38 486.602 162.753 509.57 177.511",
    stroke: "#FFEEE9",
    strokeWidth: 2.13399,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.176 148.345L305.988 136.598L309.068 140.171L280.051 155.19C277.206 156.663 274.002 157.419 270.756 157.38L264.651 157.315L270.176 148.332",
    fill: "#BC695B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.327 138.124L274.29 145.125L270.947 161.683L249.719 163.131",
    fill: "#FF906C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.232 144.461L267.733 161.879",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.561 135.453C306.307 132.481 308.489 130.342 309.359 131.229C309.842 131.711 308.061 133.524 308.061 133.524",
    fill: "#BC695B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.044 133.522C308.044 133.522 313.127 128.451 313.886 129.389C314.743 130.38 311.635 133.04 311.635 133.04C311.635 133.04 314.743 129.402 315.641 130.471C316.428 131.397 312.74 134.396 312.74 134.396C312.74 134.396 316 131.71 316.745 132.336C317.491 132.962 313.735 135.973 313.735 135.973C313.735 135.973 316.221 133.887 316.953 134.565C317.616 135.178 314.494 137.46 314.121 137.746C312.409 139.037 309.522 140.745 307.202 140.106C304.992 139.507 305.061 137.212 305.545 135.465",
    fill: "#BC695B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M315.436 134.46L314.042 135.607",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314.685 132.977L312.738 134.372",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M313.457 131.084L311.634 133.027",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M309.166 132.453L307.357 134.265",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 71,
    width: 117,
    height: 126
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M357.95 71.4259C378.349 103.668 368.35 109.144 351.114 108.883C332.413 108.596 332.192 124.568 341.57 133.29C350.948 142.012 364.234 120.682 372.77 125.376C378.156 128.335 377.217 143.342 375.836 159.065C358.033 157.644 340.189 156.275 336.847 161.699C331.875 169.756 354.484 182.299 345.23 191.151C335.977 200.004 319.072 199.808 319.376 182.142C319.652 165.636 313.671 156.158 278.232 176.51L260.056 89.6787L357.964 71.4128L357.95 71.4259Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.067 114.593C500.374 53.9682 437.602 14.7247 373.353 27.5798C310.76 40.1091 270.059 98.4398 282.503 157.683C288.787 187.592 307.252 212.285 332.071 228.074C345.703 236.757 355.371 249.964 358.547 265.205V265.257C361.13 277.552 373.781 285.557 386.819 283.132L467.145 268.152C480.169 265.727 488.649 253.784 486.08 241.476V241.424C482.945 226.509 486.024 210.929 495.057 198.335C512.045 174.671 519.406 144.854 513.067 114.593Z",
    fill: "#FF5924"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.414 292.309L230.259 309.571L221.544 309.545L221.986 293.313L232.414 292.309Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.258 309.571C231.073 310.014 232.357 310.627 234.015 311.11C237.73 312.153 240.382 311.631 241.252 313.091C241.459 313.43 241.638 314.004 241.376 314.969C237.923 318.619 222.662 318.189 220.272 316.207C218.878 312.557 221.529 309.532 221.529 309.532L230.258 309.558V309.571Z",
    fill: "#303030"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.941 314.969C219.941 314.969 230.134 317.994 241.514 314.135",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.858 292.309L260.704 309.571L251.975 309.545L252.431 293.313L262.858 292.309Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.699 309.571C261.514 310.014 262.799 310.627 264.456 311.11C268.171 312.153 270.823 311.631 271.693 313.091C271.9 313.43 272.08 314.004 271.817 314.969C268.365 318.619 253.103 318.189 250.714 316.207C249.319 312.557 251.971 309.532 251.971 309.532L260.699 309.558V309.571Z",
    fill: "#303030"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250.382 314.969C250.382 314.969 260.575 317.994 271.955 314.135",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.264 188.281L265.023 251.553V306.364H249.623L247.483 258.32L240.826 225.647L238.726 259.65L233.685 306.364H218.189L218.728 257.068C218.728 257.068 217.72 220.511 218.728 209.611C219.156 204.957 222.153 191.215 222.153 191.215L259.25 188.268L259.264 188.281Z",
    fill: "#8C3114"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M274.799 135.725L303.25 112.062L307.531 114.278L283.569 142.179L274.799 135.725Z",
    fill: "#BC695B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.558 135.922L236.567 123.927L245.737 124.918L247.229 135.478L245.461 141.958L235.558 135.922Z",
    fill: "#BC695B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229.526 117.723C231.459 128.075 240.243 130.917 249.317 127.227C258.391 123.538 248.585 110.604 246.527 107.006C244.483 103.421 226.266 100.357 229.512 117.71L229.526 117.723Z",
    fill: "#BC695B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M243.406 128.673C244.22 128.725 245.187 128.712 246.251 128.555",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 116.13C252.079 114.983 254.165 116.508 252.231 118.294L251.32 116.13Z",
    fill: "#BC695B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M250.931 120.003C250.931 120.003 251.994 120.159 252.906 119.833",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.893 114.919C250.211 115.571 250.238 116.184 249.948 116.288C249.658 116.392 249.161 115.936 248.843 115.284C248.526 114.632 248.498 114.02 248.788 113.915C249.078 113.811 249.575 114.267 249.893 114.919Z",
    fill: "#303030"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M246.885 103.888C244.495 102.467 242.023 102.441 240.214 102.441C238.225 102.441 234.993 102.441 232.162 104.318C231.016 105.074 231.803 104.905 228.35 108.412C226.817 109.963 225.919 110.746 225.712 112.115C225.615 112.793 225.754 113.353 226.03 114.448C226.541 116.443 227.121 116.913 227.535 118.282C228.198 120.511 227.066 120.72 227.687 122.388C228.461 124.448 230.739 125.57 231.955 126.156C233.667 126.991 235.297 127.304 236.333 127.434C238.805 127.434 241.001 122.975 241.001 122.975C236.83 122.023 235.96 117.786 237.686 116.86C239.8 115.726 240.822 117.825 241.802 119.52C241.996 119.859 242.175 120.224 242.355 120.589C242.907 120.263 243.487 119.976 244.15 119.781C244.095 118.477 243.75 116.991 242.769 115.648C244.606 114.853 247.382 113.744 247.99 109.364C247.769 110.993 249.633 112.063 249.633 112.063C249.785 111.189 251.139 108.386 249.246 105.935C249.039 105.661 248.28 104.709 246.885 103.888Z",
    fill: "#303030"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M235.073 110.734C235.073 110.734 239.285 109.848 240.832 106.536",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M232.966 110.851C232.966 110.851 234.651 107.97 237.606 107.513",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M233.507 107.278C233.507 107.278 235.371 104.109 237.954 104.592",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M240.091 114.382C240.091 114.382 244.303 113.496 245.85 110.184",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M237.977 114.499C237.977 114.499 239.662 111.618 242.617 111.161",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.358 115.218C234.358 115.218 235.67 111.802 238.308 111.907",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M222.332 149.53C221.02 163.846 218.741 189.517 218.741 196.571C243.96 201.355 260.976 194.172 260.976 194.172C260.976 194.172 266.113 139.361 259.622 134.576C255.382 131.46 245.01 131.786 235.812 134.224C228.381 136.206 222.995 142.255 222.318 149.517L222.332 149.53Z",
    fill: "#FF906C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M250.619 132.493L281.432 128.986L285.589 145.153L262.87 157.317",
    fill: "#FF906C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.29 150.993L262.91 156.625L262.841 162.349",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M230.169 136.442L231.412 133.326C231.412 133.326 241.564 128.893 247.944 130.627L253.013 134.148L230.169 136.429V136.442Z",
    fill: "#FF906C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.169 136.444C230.169 136.444 243.967 133.614 250.624 132.506",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M276.691 130.223L282.174 146.768",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.841 225.635L237.07 218.086L227.444 217.082",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.208 301.07H234.146",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M249.801 301.07H265.035",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M302.381 111.162C301.883 108.138 303.044 105.387 304.204 105.895C304.853 106.169 303.914 108.49 303.914 108.49",
    fill: "#BC695B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M303.909 108.476C303.909 108.476 306.589 101.971 307.652 102.557C308.84 103.17 307.031 106.742 307.031 106.742C307.031 106.742 308.453 102.27 309.71 102.935C310.815 103.509 308.591 107.603 308.591 107.603C308.591 107.603 310.525 103.952 311.464 104.265C312.403 104.578 310.138 108.698 310.138 108.698C310.138 108.698 311.602 105.882 312.555 106.247C313.411 106.586 311.45 109.806 311.216 110.197C310.138 112.01 308.163 114.604 305.76 114.852C303.467 115.087 302.611 112.935 302.363 111.149",
    fill: "#BC695B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.135 106.717L310.306 108.281",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M309.849 105.609L308.606 107.603",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M307.959 104.291L307.047 106.742",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M304.523 107.094L303.57 109.415",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 128,
    width: 68,
    height: 71
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M260.395 193.37C260.384 193.496 260.374 193.607 260.365 193.701C260.258 193.742 260.128 193.791 259.974 193.847C259.471 194.03 258.719 194.288 257.737 194.584C255.772 195.175 252.885 195.916 249.213 196.51C241.974 197.681 231.686 198.278 219.399 196.018C219.504 188.313 221.701 163.57 222.983 149.579C223.632 142.613 228.805 136.773 235.995 134.856L235.996 134.855C241.301 133.436 246.976 132.756 251.603 133.025L251.659 133.028L251.715 133.022L280.942 129.696L284.83 144.818L272.603 151.369L272.866 151.861L272.272 151.801L270.395 161.054L262.797 161.58L262.203 161.622L262.19 162.217C262.025 170.005 261.56 177.976 261.135 184.002C260.923 187.014 260.721 189.54 260.573 191.311C260.498 192.197 260.437 192.895 260.395 193.37Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.30377
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_3908)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.024 134.239L222.747 136.456",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M229.095 132.858L228.874 137.826",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M235.366 134.019L239.814 136.679",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M244.799 133.236L247.589 137.46",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M252.894 133.628L256.706 137.07",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M261.934 133.274L264.848 137.407",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M272.323 132.871L271.674 137.812",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M279.921 132.937L281.289 137.748",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M218.723 144.956L222.038 148.828",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M226.815 145.479L231.138 148.321",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.999 144.802L236.181 149.001",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M245.988 144.423L246.402 149.377",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M253.154 144.956L256.441 148.841",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M261.182 145.557L265.63 148.23",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M270.778 144.697L273.236 149.104",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M280.599 144.409L280.612 149.389",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M218.405 156.807L222.355 160.093",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M229.674 156.051L228.293 160.848",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M237.148 156.002L238.032 160.904",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M246.544 155.988L245.839 160.916",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M252.161 158.307L257.423 158.607",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M261.805 156.47L264.995 160.434",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M269.396 158.099L274.603 158.803",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M279.392 156.234L281.809 160.667",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M218.12 168.725L222.65 171.28",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M227.504 167.942L230.446 172.075",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M239.053 167.942L236.111 172.075",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M245.036 167.774L247.342 172.246",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M253.276 167.97L256.314 172.038",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M262.571 167.641L264.228 172.361",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M269.63 168.935L274.381 171.086",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M281.686 167.734L279.518 172.271",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M219.649 179.169L221.113 183.954",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M226.364 181.283L231.612 181.843",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M237.77 179.077L237.411 184.044",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M246.373 179.077L246.013 184.044",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M255.434 179.141L254.15 183.978",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M262.068 179.416L264.733 183.705",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M270.515 179.507L273.498 183.613",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M278.251 180.459L282.975 182.663",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M219.483 190.772L221.278 195.453",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M228.823 190.629L229.14 195.596",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 190.643L237.841 195.597",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M244.547 191.176L247.834 195.061",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M252.672 191.645L256.926 194.591",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M262.297 190.851L264.493 195.375",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M271.759 190.643L272.243 195.597",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M279.936 190.706L281.276 195.517",
    stroke: "#FF906C",
    strokeWidth: 1.30377,
    strokeMiterlimit: 10
  }))))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M462.591 426.661H476.499C483.501 426.661 489.192 432.033 489.192 438.643V443.78C489.192 450.39 483.501 455.761 476.499 455.761H462.591C455.589 455.761 449.899 450.39 449.899 443.78V438.656C449.899 432.046 455.589 426.674 462.591 426.674V426.661Z",
    fill: "#D4D4D4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M414.876 361.588H524.233V411.287C524.233 428.302 509.607 442.109 491.583 442.109H447.526C429.502 442.109 414.876 428.302 414.876 411.287V361.588Z",
    fill: "#D4D4D4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M527.35 352.647H411.75L414.872 361.591H524.229L527.35 352.647Z",
    fill: "#8F8F8F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M360.142 342.919C354.742 345.983 354.328 349.581 355.736 350.833C357.145 352.085 354.383 354.51 356.234 356.778C358.084 359.06 353.941 360.976 358.07 364.236C362.2 367.495 354.493 371.381 371.661 371.002C388.828 370.624 397.791 366.948 391.811 360.989C385.845 355.044 360.142 342.893 360.142 342.893V342.919Z",
    fill: "#303030"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M315.127 416.414L316.923 420.039C316.923 420.039 319.975 418.592 324.077 416.493C323.097 415.032 322.033 413.559 320.887 412.125L315.127 416.414Z",
    fill: "#BC695B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M313.817 415.957C313.817 415.957 307.257 419.165 307.989 420.103C308.762 421.146 312.326 419.073 312.326 419.073C312.326 419.073 307.768 420.886 308.597 421.994C309.329 422.972 313.389 420.442 313.389 420.442C313.389 420.442 309.743 422.646 310.185 423.493C310.627 424.341 314.715 421.772 314.715 421.772C314.715 421.772 311.897 423.454 312.395 424.301C312.837 425.071 316.027 422.88 316.414 422.62C318.209 421.42 320.737 419.282 320.737 417C320.737 414.823 318.389 414.249 316.469 414.21",
    fill: "#BC695B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M312.739 422.919L314.286 421.98",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M311.409 421.823L313.384 420.454",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M309.843 420.195L312.329 419.087",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M420.643 515.826L428.626 531.484L436.871 528.772L430.85 513.57L420.643 515.826Z",
    fill: "#D4D4D4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M428.63 531.483C428.009 532.148 427.015 533.126 425.606 534.091C422.457 536.229 419.764 536.542 419.446 538.198C419.377 538.576 419.391 539.176 419.985 540.01C424.501 542.396 438.795 537.311 440.37 534.704C440.439 530.819 436.876 528.785 436.876 528.785L428.63 531.497V531.483Z",
    fill: "#303030"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M440.259 533.413C440.259 533.413 431.654 539.398 419.569 539.254",
    stroke: "#F1F1F1",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M374.052 512.11L378.982 528.85L387.6 527.559L384.52 511.588L374.052 512.11Z",
    fill: "#D4D4D4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M378.976 528.85C378.244 529.411 377.07 530.206 375.509 530.91C372.015 532.488 369.308 532.344 368.673 533.922C368.535 534.287 368.438 534.887 368.866 535.799C372.872 538.902 387.884 536.282 389.928 533.974C390.716 530.154 387.608 527.559 387.608 527.559L378.99 528.85H378.976Z",
    fill: "#303030"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M390.055 532.683C390.055 532.683 380.47 537.141 368.593 534.977",
    stroke: "#F1F1F1",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M316.482 414.235C313.25 414.091 310.474 415.473 311.123 416.503C311.482 417.077 313.816 415.956 313.816 415.956",
    fill: "#BC695B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M312.42 416.676L314.768 415.528",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M392.584 367.325C384.146 362.905 369.685 368.29 363.07 374.392L319.164 412.931L325.807 420.871L363.926 397.494C365.943 400.115 370.335 400.35 372.972 399.893C382.419 410.767 384.436 416.086 384.436 416.086L414.641 405.2C414.641 405.2 403.578 373.088 392.598 367.325H392.584Z",
    fill: "#FF906C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 365,
    width: 96,
    height: 56
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M392.579 367.327C384.14 362.907 369.68 368.292 363.064 374.393L319.159 412.933L325.802 420.873L363.921 397.496C365.937 400.117 370.329 400.351 372.967 399.895C382.414 410.769 384.43 416.088 384.43 416.088L414.636 405.201C414.636 405.201 403.573 373.09 392.593 367.327H392.579Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.544 420.923C321.544 420.923 327.938 420.102 331.212 424.013C326.447 425.2 321.544 420.923 321.544 420.923Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.418 414.943C321.418 414.943 326.473 411.162 331.403 412.961C327.951 416.272 321.418 414.943 321.418 414.943Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.077 406.856C324.077 406.856 328.607 402.527 333.731 403.74C330.72 407.417 324.077 406.856 324.077 406.856Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34 397.535C321.34 397.535 326.713 394.159 331.464 396.323C327.735 399.361 321.34 397.535 321.34 397.535Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.962 391.173C321.962 391.173 325.636 386.167 330.912 386.532C328.619 390.652 321.962 391.173 321.962 391.173Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.533 382.189C321.533 382.189 326.201 377.978 331.283 379.334C328.162 382.932 321.533 382.189 321.533 382.189Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.949 423.845C338.949 423.845 343.659 419.686 348.728 421.094C345.565 424.653 338.949 423.845 338.949 423.845Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 412.502C338.935 412.502 345.302 411.564 348.658 415.423C343.921 416.688 338.935 412.502 338.935 412.502Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.812 406.374C338.812 406.374 343.923 402.658 348.826 404.523C345.318 407.782 338.812 406.374 338.812 406.374Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.279 399.074C339.279 399.074 343.174 394.224 348.422 394.798C345.95 398.814 339.279 399.074 339.279 399.074Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.153 390.402C342.153 390.402 347.677 387.26 352.332 389.633C348.465 392.501 342.153 390.402 342.153 390.402Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.798 381.668C338.798 381.668 343.922 377.978 348.825 379.856C345.303 383.102 338.798 381.668 338.798 381.668Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.985 425.045C356.985 425.045 360.313 419.83 365.589 419.869C363.587 424.12 356.985 425.045 356.985 425.045Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.629 415.946C356.629 415.946 360.704 411.226 365.924 411.969C363.314 415.906 356.629 415.946 356.629 415.946Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.211 406.269C356.211 406.269 361.404 402.658 366.266 404.613C362.688 407.807 356.211 406.269 356.211 406.269Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.352 394.169C356.352 394.169 362.58 392.591 366.351 396.072C361.793 397.819 356.352 394.169 356.352 394.169Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.692 387.183C357.692 387.183 363.659 384.875 367.871 387.887C363.576 390.156 357.692 387.183 357.692 387.183Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.392 382.177C356.392 382.177 361.074 377.979 366.143 379.348C363.022 382.933 356.392 382.177 356.392 382.177Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.431 425.094C374.431 425.094 377.691 419.84 382.981 419.827C381.033 424.091 374.431 425.094 374.431 425.094Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.427 416.623C377.427 416.623 381.004 411.551 386.28 411.825C384.07 415.984 377.427 416.623 377.427 416.623Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.902 407.079C373.902 407.079 378.363 402.672 383.501 403.807C380.559 407.535 373.902 407.079 373.902 407.079Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.931 398.656C373.931 398.656 378.296 394.184 383.461 395.227C380.588 399.008 373.931 398.656 373.931 398.656Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.624 391.707C374.624 391.707 377.552 386.283 382.828 385.983C381.143 390.351 374.624 391.707 374.624 391.707Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.973 386.87C368.973 386.87 374.152 383.246 379.027 385.189C375.464 388.396 368.973 386.87 368.973 386.87Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.071 423.349C391.071 423.349 396.222 419.685 401.111 421.589C397.576 424.822 391.071 423.349 391.071 423.349Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.071 414.86C391.071 414.86 396.195 411.171 401.098 413.048C397.576 416.294 391.071 414.86 391.071 414.86Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.015 405.865C391.015 405.865 396.512 402.684 401.18 405.017C397.327 407.912 391.015 405.865 391.015 405.865Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.734 411.313C389.734 411.313 395.231 408.132 399.899 410.466C396.045 413.36 389.734 411.313 389.734 411.313Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.53 398.67C393.53 398.67 397.742 394.054 402.935 394.941C400.2 398.8 393.53 398.67 393.53 398.67Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.289 390.429C391.289 390.429 395.805 386.075 400.929 387.274C397.946 390.964 391.289 390.429 391.289 390.429Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.736 392.111C403.736 392.111 408.252 387.756 413.376 388.956C410.393 392.645 403.736 392.111 403.736 392.111Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.359 384.119C392.359 384.119 397.055 379.934 402.124 381.316C398.989 384.902 392.359 384.119 392.359 384.119Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.322 373.52C356.322 373.52 361.266 369.609 366.238 371.265C362.882 374.668 356.322 373.52 356.322 373.52Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.213 374.653C374.213 374.653 377.942 369.686 383.218 370.103C380.884 374.197 374.213 374.653 374.213 374.653Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.044 373.038C391.044 373.038 396.376 369.609 401.154 371.734C397.453 374.798 391.044 373.038 391.044 373.038Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.432 422.802C408.432 422.802 413.984 419.712 418.611 422.124C414.702 424.953 408.432 422.802 408.432 422.802Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.358 416.687C409.358 416.687 412.493 411.367 417.769 411.224C415.932 415.526 409.358 416.687 409.358 416.687Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.828 404.796C406.828 404.796 411.593 400.702 416.648 402.162C413.444 405.683 406.828 404.796 406.828 404.796Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.458 398.995C404.458 398.995 410.466 396.778 414.623 399.855C410.3 402.072 404.458 398.995 404.458 398.995Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.987 390.976C408.987 390.976 412.882 386.126 418.13 386.7C415.658 390.715 408.987 390.976 408.987 390.976Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.491 379.958C408.491 379.958 414.665 378.198 418.559 381.575C414.057 383.452 408.491 379.958 408.491 379.958Z",
    fill: "#FF906C"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M361.786 385.916C362.435 388.341 362.96 391.157 362.836 393.726C362.766 395.277 363.139 396.476 363.802 397.389",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M414.625 405.201C414.625 405.201 430.798 425.657 427.705 439.699C424.611 453.741 422.76 480.077 422.76 480.077L438.091 525.631L422.594 530.65C422.594 530.65 397.803 490.533 399.129 483.01C400.455 475.488 399.074 457.522 399.074 457.522L386.506 474.653L389.378 524.392L374.766 526.478C374.766 526.478 363.261 473.819 364.145 467.756C365.029 461.694 384.075 429.934 384.075 429.934L384.42 416.101L414.625 405.214V405.201Z",
    fill: "#525252"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M399.073 457.521L398.244 436.713L392.968 434.679",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M384.336 419.085C384.336 419.085 409.748 411.51 416.833 407.442",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M420.051 526.466L436.652 521.394",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M374.052 523.113L389.189 520.805",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M379.902 366.427L375.11 359.413L364.945 361.956L368.978 370.404L366.395 373.833L370.566 382.62L379.902 366.427Z",
    fill: "#BC695B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M379.642 351.863C381.368 362.241 374.034 367.626 364.187 366.922C354.34 366.218 359.174 350.963 359.864 346.948C360.568 342.919 376.741 334.445 379.628 351.863H379.642Z",
    fill: "#BC695B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M361.356 357.391C360.238 356.531 358.663 358.043 360.652 359.138",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M363.065 360.937C363.065 360.937 361.007 361.954 359.82 360.911",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M363.027 355.578C362.944 356.295 363.138 356.882 363.442 356.882C363.745 356.882 364.063 356.321 364.146 355.604C364.229 354.887 364.036 354.3 363.732 354.3C363.428 354.3 363.11 354.861 363.027 355.578Z",
    fill: "#303030"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M358.731 355.644C358.649 356.362 358.842 356.948 359.146 356.948C359.45 356.948 359.767 356.388 359.85 355.671C359.933 354.953 359.74 354.367 359.436 354.367C359.132 354.367 358.814 354.927 358.731 355.644Z",
    fill: "#303030"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M361.352 349.035C361.352 349.035 359.957 352.164 364.597 351.929C369.238 351.694 367.332 356.31 369.984 356.388C372.636 356.466 370.122 365.944 379.886 363.819C383.256 363.115 384.168 363.65 386.157 364.132C388.146 364.602 393.863 363.48 391.957 361.381C390.052 359.282 391.833 355.997 388.077 354.51C384.32 353.024 386.24 346.44 383.325 345.736C380.425 345.032 378.105 340.573 375.536 340.338C372.967 340.104 367.581 338.305 365.578 339.791C363.589 341.277 357.568 342.842 358.051 346.831C358.451 350.117 361.338 349.022 361.338 349.022L361.352 349.035Z",
    fill: "#303030"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M363.067 343.44C363.067 343.44 363.357 346.139 366.189 346.843C369.006 347.547 367.335 350.441 370.581 350.911C373.826 351.38 372.915 357.169 376.644 356.543",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M372.433 347.3C374.726 348.238 372.682 350.351 377.447 352.306C382.198 354.262 380.375 358.004 382.943 358.134",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M370.17 343.441C370.17 343.441 372.574 343.324 374.355 345.983C376.137 348.643 379.424 348.487 379.893 350.52",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M377.433 346.974C377.433 346.974 379.781 345.657 381.852 348.708",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M379.281 358.812C379.281 358.812 381.269 363.584 386.158 363.584",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M385.591 360.221C385.591 360.221 389.32 362.489 389.734 363.584",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M358.883 345.58C358.883 345.58 359.297 347.47 362.28 347.705",
    stroke: "#3F3F3F",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M468.42 455.67V461.915C468.42 481.458 451.639 497.299 430.936 497.299H419.528C402.375 497.299 388.467 484.17 388.467 467.977C388.467 451.785 374.559 438.656 357.405 438.656H351.301",
    stroke: "#8F8F8F",
    strokeWidth: 14.7848,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M468.418 455.672V461.917C468.418 462.452 468.418 462.973 468.377 463.495",
    stroke: "#737373",
    strokeWidth: 14.7848,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M463.27 479.843C456.751 490.299 444.707 497.314 430.938 497.314H419.53C402.376 497.314 388.468 484.185 388.468 467.992C388.468 455.462 380.154 444.772 368.442 440.573",
    stroke: "#737373",
    strokeWidth: 14.7848,
    strokeMiterlimit: 10,
    strokeDasharray: "17.2 17.2"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M359.571 438.721C358.853 438.669 358.121 438.656 357.389 438.656H351.284",
    stroke: "#737373",
    strokeWidth: 14.7848,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M174.167 424.821L172.372 428.446C172.372 428.446 169.319 426.999 165.218 424.9C166.198 423.439 167.262 421.966 168.408 420.532L174.167 424.821Z",
    fill: "#FFA07C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M175.485 424.368C175.485 424.368 182.045 427.575 181.313 428.514C180.54 429.557 176.976 427.484 176.976 427.484C176.976 427.484 181.534 429.296 180.705 430.404C179.973 431.382 175.913 428.853 175.913 428.853C175.913 428.853 179.559 431.056 179.117 431.904C178.675 432.751 174.587 430.183 174.587 430.183C174.587 430.183 177.405 431.865 176.907 432.712C176.465 433.481 173.275 431.291 172.888 431.03C171.093 429.831 168.565 427.692 168.565 425.411C168.565 423.234 170.913 422.66 172.833 422.621",
    fill: "#FFA07C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M176.556 431.315L175.009 430.377",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M177.884 430.233L175.909 428.865",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M179.462 428.603L176.976 427.482",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M172.835 422.633C176.067 422.489 178.843 423.871 178.194 424.901C177.835 425.475 175.501 424.354 175.501 424.354",
    fill: "#FFA07C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M176.872 425.084L174.524 423.937",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M113.411 438.827L132.015 400.158L133.935 441.644L119.005 447.445L113.411 438.827Z",
    fill: "#FFCCBB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M145.037 515.253L142.731 532.489L134.002 532.397L134.596 516.165L145.037 515.253Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M142.736 532.491C143.551 532.934 144.822 533.573 146.479 534.055C150.181 535.137 152.832 534.629 153.703 536.102C153.896 536.441 154.075 537.015 153.799 537.98C150.319 541.604 135.057 541.057 132.682 539.049C131.315 535.385 134.008 532.386 134.008 532.386L142.736 532.478V532.491Z",
    fill: "#154059"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M132.347 537.795C132.347 537.795 142.512 540.898 153.934 537.13",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8497 515.356L46.8037 526.608L40.4368 520.975L52.4939 509.385L60.8497 515.356Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8027 526.611C47.0789 527.458 47.5761 528.736 48.4462 530.157C50.4074 533.312 52.7277 534.629 52.3134 536.272C52.2167 536.65 51.9405 537.184 51.0428 537.732C45.8774 538.175 35.0218 528.045 34.7041 525.059C36.32 521.487 40.4358 520.991 40.4358 520.991L46.8027 526.624V526.611Z",
    fill: "#154059"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3523 523.911C35.3523 523.911 40.6282 532.685 51.7462 537.183",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M139.366 375.256C140.609 377.212 141.839 379.272 143.026 381.436C147.418 389.454 150.291 397.172 152.211 404.056C158.495 409.871 164.793 415.673 171.077 421.488C171.077 421.488 164.655 427.928 163.453 427.928C162.252 427.928 140.071 413.026 140.071 413.026L128.525 394.578L139.366 375.256Z",
    fill: "#FFCCBB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3514 435.502L73.5313 478.318L42.6218 517.352L52.262 526.831C52.262 526.831 85.9752 500.299 88.3921 494.237C90.7953 488.174 107.465 458.604 107.465 458.604L132.56 479.321V529.477H146.206C146.206 529.477 156.495 475.267 152.076 470.351C147.656 465.436 120.918 435.045 120.918 435.045L78.3652 435.502H78.3514Z",
    fill: "#8C3114"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5261 435.501L120.896 435.045C120.896 435.045 124.749 424.967 128.589 413.024C133.506 397.757 138.712 379.426 139.348 375.241C131.282 366.702 116.062 360.078 100.814 369.179C85.5669 378.279 79.5452 419.204 75.5261 435.488V435.501Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M117.833 366.154L122.626 356.727L132.791 359.27L129.808 367.927L131.382 369.009C128.951 373.455 123.593 374.641 120.734 370.43L117.833 366.141V366.154Z",
    fill: "#FFA07C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M132.171 369.427L128.525 444.224H135.748L139.366 375.254C138.634 374.25 137.53 372.986 135.969 371.76C134.588 370.665 133.248 369.922 132.171 369.427Z",
    fill: "#FFCCBB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M117.349 364.825L104.035 442.712L73.5264 439.296C73.5264 439.296 84.4096 391.552 93.6493 376.767C102.889 361.983 117.349 364.825 117.349 364.825Z",
    fill: "#FFCCBB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M118.097 349.19C116.371 359.568 123.704 364.952 133.552 364.248C143.399 363.544 138.565 348.29 137.875 344.274C137.17 340.246 120.997 331.771 118.111 349.19H118.097Z",
    fill: "#FFA07C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M136.383 354.721C138.289 353.313 139.076 355.373 137.088 356.468",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M134.669 358.267C134.669 358.267 136.727 359.284 137.914 358.241",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M134.71 352.908C134.793 353.625 134.6 354.212 134.296 354.212C133.992 354.212 133.675 353.651 133.592 352.934C133.509 352.217 133.702 351.63 134.006 351.63C134.31 351.63 134.628 352.191 134.71 352.908Z",
    fill: "#303030"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M139.003 352.973C139.086 353.69 138.892 354.277 138.588 354.277C138.285 354.277 137.967 353.716 137.884 352.999C137.801 352.282 137.994 351.695 138.298 351.695C138.602 351.695 138.92 352.256 139.003 352.973Z",
    fill: "#303030"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M120.844 360.248C120.844 360.248 122.86 358.396 122.625 356.741C122.391 355.072 120.402 351.943 122.639 350.848C124.877 349.752 126.451 351.304 126.285 354.25L128.771 354.303C128.771 354.303 128.357 350.782 130.014 349.531C131.672 348.279 130.595 345.932 130.595 345.932C130.595 345.932 137.97 348.383 140.055 345.411C140.055 339.049 128.744 332.412 119.767 341.578C113.013 343.899 113.123 356.493 120.83 360.274L120.844 360.248Z",
    fill: "#303030"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M128.451 363.13C128.451 363.13 129.556 364.538 132.152 364.304",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M125.751 341.994C125.751 341.994 128.513 344.706 134.991 343.611",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M125.751 339.962C125.751 339.962 131.496 339.206 134.162 341.735",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M130.365 338.241C130.365 338.241 135.973 339.962 135.973 341.996",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M124.129 346.846C124.129 346.846 126.145 347.746 126.118 350.027",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M125.31 344.864C125.31 344.864 127.465 346.324 127.465 348.436",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M121.755 346.009C121.755 346.009 119.601 349.659 120.153 352.267",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M120.069 344.291C120.069 344.291 115.967 348.88 119.172 353.534",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M137.542 409.898L138.896 384.174",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M116.989 366.937C121.049 375.242 126.532 377.602 132.14 370.34",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M107.449 458.604L113.415 448.07",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M105.223 438.044L122.501 436.87",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0625 423.17L99.6442 425.582",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M133.013 524.195H147.059",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3215 512.687L57.5086 521.904",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M364.284 429.933H347.241V447.534H364.284V429.933Z",
    fill: "#D4D4D4"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M307.175 416.739H335.902C348.18 416.739 358.152 426.152 358.152 437.742V439.698C358.152 451.289 348.18 460.702 335.902 460.702H307.175V416.726V416.739Z",
    fill: "#D4D4D4"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M315.958 416.738H307.175V460.714H315.958V416.738Z",
    fill: "#F1F1F1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M333.702 438.733C333.702 441.953 330.94 444.561 327.528 444.561C324.117 444.561 321.355 441.953 321.355 438.733C321.355 435.512 324.117 432.905 327.528 432.905C330.94 432.905 333.702 435.512 333.702 438.733Z",
    fill: "#BFBFBF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M323.003 443.008L332.063 434.455",
    stroke: "#F1F1F1",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M309.659 460.714V416.738",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M321.621 416.74V426.818",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M324.58 416.74V426.818",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M327.532 416.74V426.818",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M330.491 416.74V426.818",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M333.442 416.74V426.818",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M321.621 450.637V460.715",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M324.58 450.637V460.715",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M327.532 450.637V460.715",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M330.491 450.637V460.715",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M333.442 450.637V460.715",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M307.174 540.583H177.625V371.184L212.568 317.873H307.174V540.583Z",
    fill: "#8F8F8F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M278.944 357.012H211.918C206.365 357.012 201.864 361.261 201.864 366.503V439.645C201.864 444.887 206.365 449.136 211.918 449.136H278.944C284.497 449.136 288.999 444.887 288.999 439.645V366.503C288.999 361.261 284.497 357.012 278.944 357.012Z",
    fill: "#303030"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M178.714 526.997H307.172",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M271.924 479.592H255.075C251.871 479.592 249.274 482.043 249.274 485.068V515.302C249.274 518.326 251.871 520.778 255.075 520.778H271.924C275.128 520.778 277.725 518.326 277.725 515.302V485.068C277.725 482.043 275.128 479.592 271.924 479.592Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M253.964 485.616C254.826 485.616 255.525 484.957 255.525 484.143C255.525 483.33 254.826 482.67 253.964 482.67C253.102 482.67 252.403 483.33 252.403 484.143C252.403 484.957 253.102 485.616 253.964 485.616Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M273.225 485.616C274.087 485.616 274.786 484.957 274.786 484.143C274.786 483.33 274.087 482.67 273.225 482.67C272.363 482.67 271.664 483.33 271.664 484.143C271.664 484.957 272.363 485.616 273.225 485.616Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M255.525 515.746C255.525 516.555 254.82 517.22 253.964 517.22C253.108 517.22 252.403 516.555 252.403 515.746C252.403 514.938 253.108 514.273 253.964 514.273C254.82 514.273 255.525 514.938 255.525 515.746Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M274.786 515.746C274.786 516.555 274.081 517.22 273.225 517.22C272.369 517.22 271.664 516.555 271.664 515.746C271.664 514.938 272.369 514.273 273.225 514.273C274.081 514.273 274.786 514.938 274.786 515.746Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M293.817 323.963H261.789C258.585 323.963 255.988 326.414 255.988 329.439V345.345C255.988 348.369 258.585 350.82 261.789 350.82H293.817C297.021 350.82 299.618 348.369 299.618 345.345V329.439C299.618 326.414 297.021 323.963 293.817 323.963Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M294.786 329.853C293.93 329.853 293.225 329.188 293.225 328.38C293.225 327.571 293.93 326.906 294.786 326.906C295.642 326.906 296.347 327.571 296.347 328.38C296.347 329.188 295.642 329.853 294.786 329.853Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M294.786 348.042C295.648 348.042 296.347 347.383 296.347 346.569C296.347 345.755 295.648 345.096 294.786 345.096C293.924 345.096 293.225 345.755 293.225 346.569C293.225 347.383 293.924 348.042 294.786 348.042Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M261.308 329.853C260.451 329.853 259.747 329.188 259.747 328.38C259.747 327.571 260.451 326.906 261.308 326.906C262.164 326.906 262.868 327.571 262.868 328.38C262.868 329.188 262.164 329.853 261.308 329.853Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M261.308 348.042C262.17 348.042 262.868 347.383 262.868 346.569C262.868 345.755 262.17 345.096 261.308 345.096C260.446 345.096 259.747 345.755 259.747 346.569C259.747 347.383 260.446 348.042 261.308 348.042Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 357,
    width: 88,
    height: 93
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M278.941 357.011H211.915C206.362 357.011 201.861 361.261 201.861 366.503V439.644C201.861 444.886 206.362 449.136 211.915 449.136H278.941C284.494 449.136 288.996 444.886 288.996 439.644V366.503C288.996 361.261 284.494 357.011 278.941 357.011Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.829 382.997V378.225L270.022 378.994V382.227L264.829 382.997Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.827 378.225V382.997L217.648 382.227V378.994L222.827 378.225Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.426 376.075L262.699 371.59L267.851 370.639L269.025 373.676L264.426 376.075Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24 385.148L224.966 389.633L219.814 390.585L218.64 387.547L223.24 385.148Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.542 369.685L258.296 366.047L262.798 363.479L264.994 365.956L261.542 369.685Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13 391.525L229.375 395.176L224.873 397.744L222.677 395.267L226.13 391.525Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.513 364.628L252.148 362.255L255.449 358.396L258.405 360.012L256.513 364.628Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.144 396.584L235.522 398.97L232.221 402.829L229.265 401.212L231.144 396.584Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.969 361.497L244.997 360.675L246.696 355.982L250.066 356.543L249.969 361.497Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.702 399.723L242.674 400.544L240.975 405.238L237.605 404.677L237.702 399.723Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.674 360.675L237.702 361.497L237.605 356.543L240.975 355.982L242.674 360.675Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.997 400.544L249.969 399.723L250.066 404.677L246.696 405.238L244.997 400.544Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.522 362.255L231.144 364.628L229.265 360.012L232.221 358.396L235.522 362.255Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.148 398.97L256.513 396.584L258.405 401.212L255.449 402.829L252.148 398.97Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.375 366.047L226.13 369.685L222.677 365.956L224.873 363.479L229.375 366.047Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.296 395.176L261.542 391.525L264.994 395.267L262.798 397.744L258.296 395.176Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.966 371.59L223.24 376.075L218.64 373.676L219.814 370.639L224.966 371.59Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.699 389.633L264.426 385.148L269.025 387.547L267.851 390.585L262.699 389.633Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.713 380.612C265.713 369.204 255.92 359.96 243.836 359.96C231.751 359.96 221.959 369.204 221.959 380.612C221.959 392.02 231.751 401.264 243.836 401.264C255.92 401.264 265.713 392.02 265.713 380.612ZM229.03 380.612C229.03 372.894 235.659 366.636 243.836 366.636C252.012 366.636 258.641 372.894 258.641 380.612C258.641 388.33 252.012 394.588 243.836 394.588C235.659 394.588 229.03 388.33 229.03 380.612Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.512 380.611C251.512 376.608 248.073 373.362 243.833 373.362C239.593 373.362 236.154 376.608 236.154 380.611C236.154 384.613 239.593 387.86 243.833 387.86C248.073 387.86 251.512 384.613 251.512 380.611ZM241.305 380.611C241.305 379.294 242.438 378.225 243.833 378.225C245.228 378.225 246.36 379.294 246.36 380.611C246.36 381.928 245.228 382.997 243.833 382.997C242.438 382.997 241.305 381.928 241.305 380.611Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.751 369.541L245.649 377.227L247.845 380.817L261.947 373.131L259.751 369.541Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.812 380.405L225.71 388.09L227.906 391.681L242.008 383.995L239.812 380.405Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.034 362.046H241.642V377.417H246.034V362.046Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.034 383.792H241.642V399.164H246.034V383.792Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.906 369.506L225.71 373.096L239.812 380.782L242.008 377.191L227.906 369.506Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.849 380.424L245.653 384.014L259.754 391.7L261.95 388.109L247.849 380.424Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.023 358.655V354.666L286.36 355.305V358.016L282.023 358.655Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.295 357.901L264.745 361.656L260.436 362.451L259.455 359.909L263.295 357.901Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.177 363.299L269.837 365.294L267.075 368.527L264.603 367.171L266.177 363.299Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.439 365.644L276.596 364.94L276.679 369.086L273.862 369.556L272.439 365.644Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.594 363.908L281.301 360.857L284.188 363.973L282.351 366.046L278.594 363.908Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.356 356.662C283.356 351.134 278.605 346.662 272.763 346.662C266.921 346.662 262.17 351.147 262.17 356.662C262.17 362.177 266.921 366.662 272.763 366.662C278.605 366.662 283.356 362.177 283.356 356.662ZM267.639 356.662C267.639 353.989 269.932 351.825 272.763 351.825C275.594 351.825 277.887 353.989 277.887 356.662C277.887 359.334 275.594 361.499 272.763 361.499C269.932 361.499 267.639 359.334 267.639 356.662Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.426 397.585L267.467 401.757L262.923 401.119L262.896 398.289L267.426 397.585Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.041 395.553L288.789 391.968L293.057 390.364L294.576 392.802L291.041 395.553Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.004 403.556L270.241 407.142L265.974 408.745L264.455 406.307L268.004 403.556Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.366 390.651L283.527 388.604L286.372 385.201L288.982 386.596L287.366 390.651Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.663 408.459L275.502 410.506L272.657 413.909L270.047 412.514L271.663 408.459Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.606 388.135L277.187 388.187L277.85 383.885L280.847 383.859L281.606 388.135Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.427 410.975L281.847 410.922L281.184 415.225L278.187 415.251L277.427 410.975Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.284 388.683L271.472 390.808L269.787 386.779L272.356 385.332L275.284 388.683Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.749 410.429L287.561 408.304L289.26 412.333L286.677 413.78L283.749 410.429Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.091 392.136L267.922 395.773L264.318 393.074L265.782 390.623L270.091 392.136Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.945 406.974L291.113 403.336L294.718 406.035L293.254 408.486L288.945 406.974Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.117 399.437C292.048 392.866 286.358 387.599 279.397 387.664C272.436 387.73 266.856 393.101 266.925 399.672C266.994 406.243 272.685 411.51 279.646 411.445C286.606 411.38 292.186 406.008 292.117 399.437ZM271.055 399.633C271.014 395.226 274.756 391.615 279.438 391.563C284.107 391.524 287.932 395.057 287.988 399.477C288.029 403.883 284.286 407.495 279.604 407.547C274.936 407.586 271.11 404.053 271.055 399.633Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.941 399.516C283.913 397.208 281.925 395.37 279.48 395.383C277.035 395.396 275.088 397.286 275.102 399.594C275.13 401.902 277.118 403.74 279.563 403.727C282.007 403.701 283.955 401.824 283.941 399.516ZM278.057 399.568C278.057 398.812 278.693 398.186 279.494 398.186C280.295 398.186 280.958 398.786 280.958 399.542C280.958 400.298 280.323 400.924 279.521 400.924C278.72 400.924 278.057 400.324 278.057 399.568Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.713 393.209L280.638 397.711L281.755 399.496L289.829 394.994L288.713 393.209Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.295 399.578L269.221 404.081L270.338 405.866L278.412 401.363L277.295 399.578Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.501 388.858L278.305 388.879L278.398 397.731L280.594 397.71L280.501 388.858Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.627 401.386L278.431 401.406L278.524 410.259L280.72 410.238L280.627 401.386Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.197 393.438L269.117 395.243L277.284 399.594L278.363 397.789L270.197 393.438Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.747 399.571L280.668 401.377L288.835 405.728L289.914 403.923L281.747 399.571Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.189 432.033L221.612 435.409L218.518 431.407L220.949 429.112L225.189 432.033Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.28 437.195L218.139 441.524L213.789 438.76L215.239 435.826L220.28 437.195Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.955 451.838L259.383 447.092L264.479 448.278L264.189 451.499L258.955 451.838Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.549 443.636L217.107 448.382L212.011 447.196L212.315 443.975L217.549 443.636Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.193 444.915L257.881 440.313L263.101 439.778L263.985 442.907L259.193 444.915Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.896 438.317L253.996 434.418L258.719 432.241L260.68 434.888L256.896 438.317Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.362 432.867L248.219 430.129L251.865 426.557L254.669 428.421L252.362 432.867Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.128 429.203L241.253 427.977L243.38 423.44L246.68 424.275L246.128 429.203Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.933 427.783L233.905 428.2L234.264 423.258L237.676 422.972L238.933 427.783Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.664 428.758L227.078 430.779L225.628 426.02L228.736 424.651L231.664 428.758Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.721 462.348C262.271 454.278 262.271 441.201 253.721 433.13C245.172 425.06 231.32 425.06 222.77 433.13C214.221 441.201 214.221 454.278 222.77 462.348C231.32 470.418 245.172 470.418 253.721 462.348ZM227.784 437.863C233.571 432.4 242.935 432.4 248.722 437.863C254.509 443.326 254.509 452.165 248.722 457.628C242.935 463.091 233.571 463.091 227.784 457.628C221.997 452.165 221.997 443.326 227.784 437.863Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.679 452.868C246.676 450.039 246.676 445.45 243.679 442.62C240.682 439.791 235.821 439.791 232.824 442.62C229.827 445.45 229.827 450.039 232.824 452.868C235.821 455.697 240.682 455.697 243.679 452.868ZM236.456 446.049C237.437 445.124 239.039 445.124 240.019 446.049C241 446.975 241 448.487 240.019 449.413C239.039 450.339 237.437 450.339 236.456 449.413C235.475 448.487 235.475 446.975 236.456 446.049Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.082 446.566L240.945 450.57L256.674 454.549L257.811 450.544L242.082 446.566Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.814 440.934L218.677 444.938L234.406 448.917L235.542 444.912L219.814 440.934Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.589 433.148L239.075 444.017L242.181 446.949L253.695 436.08L250.589 433.148Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.313 448.528L222.799 459.398L225.904 462.329L237.419 451.46L234.313 448.528Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.292 429.261L231.05 430.334L235.264 445.182L239.507 444.109L235.292 429.261Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.022 444.679L267.226 448.291L263.58 445.97L264.795 443.519L269.022 444.679Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.819 452.851L286.192 448.875L290.459 449.879L290.211 452.565L285.819 452.851Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.558 446.818L283.141 443.546L287.077 441.72L288.721 443.937L285.558 446.818Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.042 442.059L276.968 441.029L278.749 437.235L281.512 437.939L281.042 442.059Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.698 441.236L270.873 442.918L269.657 438.929L272.254 437.794L274.698 441.236Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.138 457.195C288.281 453.284 288.281 446.948 284.138 443.049C279.994 439.138 273.282 439.138 269.153 443.049C265.023 446.961 265.009 453.297 269.153 457.195C273.296 461.093 280.008 461.106 284.138 457.195ZM273.02 446.7C275.022 444.809 278.268 444.809 280.271 446.7C282.273 448.59 282.273 451.654 280.271 453.545C278.268 455.435 275.022 455.435 273.02 453.545C271.017 451.654 271.017 448.59 273.02 446.7Z",
    fill: "#525252"
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M340.694 419.646C337.462 419.502 334.686 420.884 335.335 421.914C335.694 422.488 338.028 421.367 338.028 421.367",
    fill: "#BC695B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M339.351 421.822L341.146 425.446C341.146 425.446 344.199 423.999 348.3 421.9C347.32 420.44 346.256 418.967 345.11 417.533L339.351 421.822Z",
    fill: "#BC695B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M338.041 421.367C338.041 421.367 331.48 424.574 332.212 425.513C332.986 426.556 336.549 424.483 336.549 424.483C336.549 424.483 331.991 426.295 332.82 427.403C333.552 428.381 337.612 425.852 337.612 425.852C337.612 425.852 333.966 428.055 334.408 428.903C334.85 429.75 338.938 427.182 338.938 427.182C338.938 427.182 336.121 428.863 336.618 429.711C337.06 430.48 340.25 428.29 340.637 428.029C342.433 426.83 344.96 424.691 344.96 422.41C344.96 420.232 342.612 419.659 340.692 419.62",
    fill: "#BC695B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M336.951 428.314L338.512 427.375",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M335.633 427.232L337.608 425.863",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M334.066 425.602L336.552 424.481",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M336.644 422.083L338.992 420.936",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M398.244 379.775C398.244 379.775 395.592 403.595 381.864 411.535C368.135 419.475 349.104 426.163 349.104 426.163L342.902 418.223L368.135 398.158L377.43 376.842",
    fill: "#FF906C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_3908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 342,
    y: 376,
    width: 57,
    height: 51
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M398.25 379.772C398.25 379.772 395.598 403.592 381.87 411.532C368.142 419.472 349.11 426.16 349.11 426.16L342.908 418.22L368.142 398.155L377.436 376.839",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.917 407.072C373.917 407.072 378.378 402.666 383.516 403.8C380.574 407.529 373.917 407.072 373.917 407.072Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.684 409.72C377.684 409.72 383.512 407.099 387.89 409.889C383.733 412.393 377.684 409.72 377.684 409.72Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.943 398.652C373.943 398.652 378.308 394.18 383.473 395.223C380.6 399.004 373.943 398.652 373.943 398.652Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.821 383.37C380.821 383.37 385.185 378.898 390.35 379.941C387.478 383.722 380.821 383.37 380.821 383.37Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.636 391.7C374.636 391.7 377.564 386.276 382.84 385.976C381.155 390.344 374.636 391.7 374.636 391.7Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.023 405.86C391.023 405.86 396.52 402.679 401.188 405.012C397.335 407.907 391.023 405.86 391.023 405.86Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72 398.665C386.72 398.665 390.932 394.049 396.125 394.936C393.391 398.795 386.72 398.665 386.72 398.665Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.305 390.422C391.305 390.422 395.821 386.068 400.945 387.267C397.962 390.957 391.305 390.422 391.305 390.422Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.135 421.74C342.135 421.74 346.596 417.333 351.734 418.467C348.792 422.196 342.135 421.74 342.135 421.74Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.161 413.306C342.161 413.306 346.525 408.834 351.691 409.877C348.818 413.658 342.161 413.306 342.161 413.306Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.843 406.367C342.843 406.367 345.77 400.943 351.046 400.643C349.361 405.011 342.843 406.367 342.843 406.367Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.249 420.527C359.249 420.527 364.745 417.346 369.414 419.68C365.56 422.574 359.249 420.527 359.249 420.527Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.645 413.461C359.645 413.461 363.857 408.846 369.05 409.732C366.316 413.592 359.645 413.461 359.645 413.461Z",
    fill: "#FF906C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.522 405.09C359.522 405.09 364.039 400.735 369.163 401.934C366.179 405.624 359.522 405.09 359.522 405.09Z",
    fill: "#FF906C"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M365.026 400.648L368.134 398.17L377.429 376.854",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M398.243 379.776C398.243 379.776 395.591 403.596 381.863 411.536C380.593 412.266 379.294 412.983 377.955 413.7",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M222.133 411.509C219.178 404.091 223.155 395.825 231 393.035L251.51 385.76C242.187 377.468 228.348 374.391 215.545 378.928C205.173 382.605 197.784 390.493 194.704 399.749C193.254 404.091 189.663 407.507 185.119 409.006L50.9021 453.334C40.9442 456.62 35.7927 467.011 39.5079 476.333C43.2231 485.655 54.3411 490.27 64.1333 486.554L196.044 436.411C200.519 434.717 205.601 435.042 209.717 437.415C218.501 442.461 229.564 443.791 239.936 440.114C252.725 435.577 260.998 424.638 262.214 412.605L241.704 419.88C233.845 422.67 225.089 418.915 222.133 411.509ZM60.5838 479.462C55.2665 481.352 49.3415 478.81 47.3526 473.79C45.35 468.771 48.0432 463.178 53.3605 461.3C58.6778 459.41 64.6028 461.952 66.5916 466.959C68.5805 471.965 65.9011 477.571 60.5976 479.449L60.5838 479.462Z",
    fill: "#BFBFBF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M211.608 415.251C216.234 426.88 229.977 432.76 242.296 428.393L259.629 422.239C260.997 419.188 261.88 415.942 262.212 412.604L241.702 419.879C233.844 422.669 225.087 418.914 222.132 411.509C219.176 404.09 223.154 395.824 230.999 393.034L251.508 385.759C248.926 383.465 245.998 381.561 242.849 380.127L225.516 386.281C213.196 390.648 206.967 403.621 211.594 415.251H211.608Z",
    fill: "#A1A1A1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9349 460.27C47.1342 462.33 44.2062 468.432 46.3884 473.907C48.5705 479.383 55.0342 482.147 60.8349 480.087C66.6356 478.027 69.5636 471.926 67.3814 466.45C65.1992 460.974 58.7356 458.21 52.9349 460.27ZM59.5643 476.893C55.6281 478.288 51.2499 476.411 49.7721 472.695C48.2943 468.979 50.2831 464.846 54.2193 463.451C58.1555 462.056 62.5337 463.934 64.0115 467.649C65.4893 471.365 63.5004 475.498 59.5643 476.893Z",
    fill: "#A1A1A1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M171.376 421.653L85.2358 450.101C79.9738 451.835 77.2668 457.324 79.2279 462.239C81.1891 467.167 87.0589 469.592 92.2243 467.637L176.887 435.46C180.823 433.96 182.771 429.775 181.279 426.02C179.787 422.265 175.395 420.336 171.39 421.653H171.376Z",
    fill: "#A1A1A1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M159.275 432.293L157.479 435.917C157.479 435.917 154.427 434.47 150.325 432.371C151.306 430.911 152.369 429.438 153.515 428.003L159.275 432.293Z",
    fill: "#FFA07C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M160.585 431.834C160.585 431.834 167.145 435.041 166.413 435.98C165.64 437.023 162.077 434.95 162.077 434.95C162.077 434.95 166.634 436.762 165.806 437.87C165.074 438.848 161.013 436.319 161.013 436.319C161.013 436.319 164.659 438.522 164.217 439.37C163.775 440.217 159.687 437.649 159.687 437.649C159.687 437.649 162.505 439.331 162.007 440.178C161.566 440.947 158.375 438.757 157.988 438.496C156.193 437.297 153.666 435.159 153.666 432.877C153.666 430.7 156.013 430.126 157.933 430.087",
    fill: "#FFA07C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M161.682 438.799L160.135 437.86",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M162.985 437.718L161.024 436.336",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M164.577 436.072L162.091 434.964",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M157.932 430.115C161.163 429.971 163.94 431.353 163.29 432.383C162.931 432.957 160.597 431.836 160.597 431.836",
    fill: "#FFA07C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M161.993 432.551L159.632 431.417",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6008 390.78C93.6008 390.78 110.865 413.896 116.887 418.446C122.908 422.996 149.799 435.5 149.799 435.5L155.544 427.925L128.529 405.565L107.813 372.593",
    fill: "#FFCCBB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M114.264 382.866L107.814 372.593",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M137.548 413.036L131.679 408.173",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M129.438 425.577C131.8 426.79 134.258 428.015 136.606 429.176",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6008 390.78C93.6008 390.78 102.288 402.41 109.484 410.806",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M248.282 386.778L231.902 392.592L229.057 408.89L242.578 419.372L258.958 413.557L261.817 397.26L248.282 386.778Z",
    fill: "#D4D4D4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M251.902 400.78C253.242 404.157 251.432 407.912 247.869 409.189C244.292 410.454 240.314 408.746 238.961 405.382C237.621 402.006 239.43 398.251 242.994 396.973C246.571 395.708 250.548 397.416 251.902 400.78Z",
    fill: "#BFBFBF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M414.876 367.221H524.233",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M449.899 442.083H489.205",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M612.872 323.623H589.172C586.464 323.623 584.269 325.695 584.269 328.251V385.252C584.269 387.808 586.464 389.88 589.172 389.88H612.872C615.58 389.88 617.775 387.808 617.775 385.252V328.251C617.775 325.695 615.58 323.623 612.872 323.623Z",
    fill: "#D4D4D4"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M612.948 383.817V329.671C612.948 328.361 611.822 327.299 610.434 327.299H589.745C588.356 327.299 587.231 328.361 587.231 329.671V383.817C587.231 385.127 588.356 386.19 589.745 386.19H610.434C611.822 386.19 612.948 385.127 612.948 383.817Z",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M602.896 344.521H596.267V368.953H602.896V344.521Z",
    fill: "#737373"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M596.265 368.966C589.11 368.966 583.323 363.49 583.323 356.749C583.323 350.009 589.124 344.533 596.265 344.533",
    fill: "#737373"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M575.161 367.57L583.614 359.291H590.174L584.733 368.548L579.194 370.308L575.161 367.57Z",
    fill: "#525252"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M602.908 368.966C595.754 368.966 589.967 363.49 589.967 356.749C589.967 350.009 595.768 344.533 602.908 344.533",
    fill: "#A1A1A1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M600.542 363.19L584.728 373.06L580.102 367.349L594.327 355.524L600.542 363.19Z",
    fill: "#A1A1A1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M579.802 373.268L584.733 373.06L580.106 367.349L575.161 367.571L579.802 373.268Z",
    fill: "#737373"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M602.813 362.107C599.65 362.107 597.082 359.682 597.082 356.696C597.082 353.71 599.65 351.285 602.813 351.285",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M554.482 386.713C557.368 384.993 560.683 384.901 560.641 386.179C560.628 386.883 557.865 387 557.865 387",
    fill: "#FFA07C"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M516.741 390.963C527.873 393.909 554.294 392.592 554.294 392.592L556.614 388.746L526.782 382.319L516.755 390.976L516.741 390.963Z",
    fill: "#FFA07C"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M557.871 386.998C557.871 386.998 565.661 386.724 565.495 387.95C565.357 389.293 560.951 389.136 560.951 389.136C560.951 389.136 566.13 388.563 565.979 389.997C565.854 391.248 560.73 390.922 560.73 390.922C560.73 390.922 565.288 391.17 565.343 392.161C565.412 393.152 560.233 392.8 560.233 392.8C560.233 392.8 563.741 392.956 563.755 393.986C563.755 394.912 559.639 394.456 559.142 394.404C556.835 394.182 553.341 393.452 552.084 391.366C550.883 389.371 552.734 387.702 554.46 386.711",
    fill: "#FFA07C"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M562.678 392.853L560.744 392.749",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M563.298 391.211L560.729 390.924",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M563.856 388.942L560.955 389.137",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M559.543 386.974L556.767 387.078",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M489.935 532.889C489.935 532.889 488.734 535.367 489.535 537.831C493.098 538.835 505.21 540.151 505.21 540.151C505.21 540.151 505.942 537.935 502.738 536.227C497.932 533.685 495.791 532.355 495.791 532.355L489.949 532.876L489.935 532.889Z",
    fill: "#5E1A1E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M489.933 532.889C489.933 532.889 494.809 536.657 499.933 534.727C496.121 532.537 495.776 532.367 495.776 532.367L489.933 532.889Z",
    fill: "#FFA07C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M519.646 535.08C519.646 535.08 518.762 537.661 519.853 540.034C523.527 540.647 535.709 540.634 535.709 540.634C535.709 540.634 536.165 538.352 532.767 537.009C527.684 535.014 525.406 533.893 525.406 533.893L519.646 535.08Z",
    fill: "#5E1A1E"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M519.644 535.08C519.644 535.08 524.948 538.3 529.796 535.823C525.749 534.063 525.39 533.893 525.39 533.893L519.631 535.08H519.644Z",
    fill: "#FFA07C"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M579.006 370.675C580.208 367.663 582.791 365.707 583.578 366.737C584.02 367.311 581.879 368.967 581.879 368.967",
    fill: "#FFA07C"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M508.817 358.72L510.778 347.103L519.645 348.733L520.225 359.137L517.96 365.33L508.817 358.72Z",
    fill: "#FFA07C"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M503.399 357.964C511.009 353.466 522.817 351.771 531.007 356.712C523.425 369.189 503.399 357.964 503.399 357.964Z",
    fill: "#FFA07C"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M530.979 465.447L525.399 533.882L519.64 535.068C519.64 535.068 513.494 505.955 512.596 494.821C511.699 483.686 517.016 465.095 517.016 465.095",
    fill: "#FFA07C"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M511.701 471.038L495.693 533.945L490.059 532.993C490.059 532.993 488.581 504.128 489.644 493.006C490.694 481.885 499.16 464.584 499.16 464.584",
    fill: "#FFA07C"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M546.601 368.524L553.078 372.175L582.703 371.054L584.222 375.017C584.222 375.017 558.064 381.888 552.65 382.553C547.236 383.218 539.032 378.668 539.032 378.668L546.587 368.538L546.601 368.524Z",
    fill: "#FFA07C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M495.777 398.758L495.888 372.161C495.915 365.812 499.382 359.918 505.072 356.529C505.072 356.529 512.502 362.526 528.855 355.042C549.019 369.253 549.834 369.84 549.834 369.84L545.47 382.356L532.639 377.011L524.104 401.17C520.237 401.404 515.803 401.431 510.928 401.079C505.155 400.648 500.059 399.762 495.777 398.758Z",
    fill: "#525252"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M495.778 398.761C495.778 398.761 484.37 415.566 486.814 428.044C489.259 440.521 491.897 468.056 490.888 473.806C517.779 477.117 529.919 474.679 536.023 470.586C533.068 436.44 530.527 409.465 524.104 401.173C505.142 399.556 495.778 398.761 495.778 398.761Z",
    fill: "#737373"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M581.889 368.983C581.889 368.983 587.938 364.341 588.588 365.41C589.333 366.558 585.715 368.944 585.715 368.944C585.715 368.944 589.485 365.541 590.286 366.766C590.977 367.835 586.682 370.495 586.682 370.495C586.682 370.495 590.466 368.096 591.156 368.852C591.847 369.609 587.483 372.268 587.483 372.268C587.483 372.268 590.383 370.404 591.046 371.212C591.64 371.942 588.063 373.924 587.635 374.172C585.66 375.306 582.4 376.714 580.066 375.749C577.842 374.837 578.243 372.451 578.989 370.691",
    fill: "#FFA07C"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M589.473 370.923L587.857 371.94",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M588.907 369.267L586.683 370.48",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M587.899 367.128L585.717 368.927",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M583.219 368.018L581.051 369.673",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M532.638 376.999L526.326 374.457",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M491.041 468.89C491.041 468.89 513.898 475.343 535.595 465.761",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M495.251 399.738C495.251 399.738 507.336 405.279 524.904 402.228",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M548.508 368.89L543.799 381.654",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M529.783 355.694C526.123 358.954 510.986 363.426 504.288 356.92",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M527.311 342.342C523.858 352.095 514.922 353.646 506.705 348.848C498.487 344.05 509.964 332.864 512.492 329.67C515.019 326.476 533.112 325.993 527.311 342.356V342.342Z",
    fill: "#FFA07C"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M506.797 337.897C506.231 336.684 504.159 337.323 505.347 339.109L506.797 337.897Z",
    fill: "#FFA07C"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M506.084 341.481C506.084 341.481 505.256 341.481 504.496 341.181",
    stroke: "#303030",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M508.33 335.939C507.915 336.526 507.805 337.112 508.067 337.256C508.33 337.399 508.882 337.021 509.283 336.434C509.683 335.848 509.807 335.261 509.545 335.118C509.283 334.974 508.73 335.352 508.33 335.939Z",
    fill: "#303030"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M514.277 340.074C518.033 335.733 521.431 337.036 516.597 342.33C511.445 347.975 516.887 351.43 519.939 351.013C523.005 350.596 526.334 348.353 528.696 342.773C531.057 337.193 529.082 329.813 523.558 327.845C518.033 325.876 513.13 327.532 511.003 330.752C508.876 333.973 514.705 335.785 514.705 335.785L512.592 339.266L514.29 340.087L514.277 340.074Z",
    fill: "#303030"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M524.961 346.957C526.453 349.421 526.287 350.66 525.859 351.338C525.238 352.316 523.939 352.277 523.649 353.281C523.373 354.206 524.368 354.636 524.671 355.927C525.21 358.131 522.89 359.147 523.152 361.207C523.387 363.059 525.541 364.48 527.295 364.962C530.099 365.745 532.848 364.402 534.325 362.733C534.491 362.537 536.218 360.543 535.969 357.922C535.707 355.236 533.58 354.245 534.077 351.977C534.325 350.816 534.933 350.829 535.071 349.656C535.32 347.492 533.483 345.706 533.179 345.406C532.475 344.715 532.475 345.028 529.519 343.255C527.668 342.146 527.268 341.781 526.37 341.716C525.445 341.651 523.981 341.899 524.975 346.944L524.961 346.957Z",
    fill: "#303030"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M528.68 342.773C528.68 342.773 525.531 344.077 525.49 347.936C524.012 346.932 523.791 346.88 523.791 346.88C523.791 346.88 523.97 342.76 527.423 342.03C528.127 342.421 528.818 342.852 528.818 342.852",
    fill: "#FF7A50"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M513.51 330.31C513.51 330.31 513.496 331.835 515.761 332.839C518.027 333.843 519.601 334.639 520.084 335.616",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M516.965 329.786C516.965 329.786 517.228 331.298 519.852 332.667C522.476 334.036 524.672 334.962 523.443 336.331",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M521.498 329.932C521.498 329.932 527.589 333.088 526.595 335.095",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M519.739 342.264C519.739 342.264 517.916 347.284 519.449 348.64",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M522.393 341.39C522.393 341.39 518.844 344.076 521.026 346.944",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M527.654 347.62C527.654 347.62 529.657 348.989 528.538 351.036C527.419 353.083 525.969 353.943 527.516 355.638",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M529.357 353.556C529.357 353.556 531.705 357.168 529.536 359.058",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M530.616 346.931C530.616 346.931 534.165 347.583 532.011 351.025",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M532.282 356.292C532.282 356.292 534.271 360.646 532.724 361.429",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M526.164 358.888C526.164 358.888 525.722 361.039 527.655 362.16",
    stroke: "#525252",
    strokeWidth: 0.560621,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceProvidersTabbing);
export default __webpack_public_path__ + "static/media/ServiceProvidersTabbing.0059a348aedb6d491146eec720d4bb2e.svg";
export { ForwardRef as ReactComponent };